(function () {
  function setItemOpen(item, shouldOpen) {
    var answer = item.querySelector('.sibrille-faq-page__faq-answer');
    var button = item.querySelector('.sibrille-faq-page__faq-question');

    item.classList.toggle('is-open', shouldOpen);

    if (button) {
      button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    }

    if (answer) {
      if (shouldOpen) {
        answer.removeAttribute('hidden');
      } else {
        answer.setAttribute('hidden', '');
      }
    }
  }

  function initFaqPage(root) {
    if (root.dataset.sibrilleFaqInitialized === 'true') return;
    root.dataset.sibrilleFaqInitialized = 'true';

    var allowMultiple = root.dataset.allowMultiple !== 'false';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));

    items.forEach(function (item) {
      setItemOpen(item, false);
    });

    items.forEach(function (item) {
      var button = item.querySelector('.sibrille-faq-page__faq-question');

      if (!button) return;

      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (!allowMultiple && !isOpen) {
          items.forEach(function (otherItem) {
            if (otherItem !== item) {
              setItemOpen(otherItem, false);
            }
          });
        }

        setItemOpen(item, !isOpen);
      });
    });
  }

  function initAllFaqPages() {
    document.querySelectorAll('.sibrille-faq-page__hero-image').forEach(function (image) {
      if (image.dataset.sibrilleLoadStateBound === 'true') return;
      image.dataset.sibrilleLoadStateBound = 'true';

      if (image.complete) {
        image.classList.add('is-loaded');
        return;
      }

      image.addEventListener('load', function () {
        image.classList.add('is-loaded');
      }, { once: true });

      image.addEventListener('error', function () {
        image.classList.add('is-loaded');
      }, { once: true });
    });

    document.querySelectorAll('[data-sibrille-faq-page]').forEach(initFaqPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFaqPages, { once: true });
  } else {
    initAllFaqPages();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-sibrille-faq-page]').forEach(initFaqPage);
  });
})();
